export default {
  tradeIdeas: [],
  historyTradeIdeas: [],
  isLoading: true,
};
